import type { FC } from 'react';
import { ToastContainer } from 'react-toastify';
import { useTranslation } from 'next-i18next';
import type { CouponPaymentSourceSB } from '@mwl/core-lib';
import { selectChangeStatusDelay, selectCouponSelectedBetsV2, selectIsCouponQuickBetsV2, selectShowProgress, selectUserCurrency, selectUserIsAuthenticated, useLocalizedNumberFormatters } from '@mwl/core-lib';
import { couponToastContainerId } from '@/constants';
import { useAccountSelectItems, useTypedDispatch, useTypedSelector } from '@/hooks';
import { setShowMobileCoupon, setShowPreviewCoupon } from '@/store';
import { commonToastOptions } from '../../SportCoupon.data';
import { useCouponNotifications } from '../../SportCoupon.hooks';
import { CouponAccountSelectItem } from '../CouponAccountSelectItem/CouponAccountSelectItem';
import { CouponBetsCounter } from '../CouponBetsCounter/CouponBetsCounter';
import { CouponCreateProgress } from '../CouponCreateProgress/CouponCreateProgress';
import { CouponEmptyBlock } from '../CouponEmptyBlock/CouponEmptyBlock';
import { CouponQuickBetSwitch } from '../CouponQuickBetSwitch/CouponQuickBetSwitch';
import { CouponSubmit } from '../CouponSubmit/CouponSubmit';
import { CouponSum } from '../CouponSum/CouponSum';
import styles from './CouponPreviewBody.module.scss';
const defaultProgressDuration = 10_000;
const CouponPreviewBody: FC = () => {
  const {
    t
  } = useTranslation('sport');
  const dispatch = useTypedDispatch();
  const isAuth = useTypedSelector(selectUserIsAuthenticated);
  const selectedBets = useTypedSelector(selectCouponSelectedBetsV2);
  const isQuickBets = useTypedSelector(selectIsCouponQuickBetsV2);
  const currency = useTypedSelector(selectUserCurrency);
  const statusDelay = useTypedSelector(selectChangeStatusDelay);
  const isShowProgress = useTypedSelector(selectShowProgress);
  const {
    firstFreebetAndBonusAccount,
    setActiveItem
  } = useAccountSelectItems();
  const {
    formatPriceByCurrencyCodeWithLocale
  } = useLocalizedNumberFormatters();
  useCouponNotifications(couponToastContainerId);
  const handleSelectItem = ({
    id,
    type
  }: CouponPaymentSourceSB) => {
    dispatch(setShowMobileCoupon(true));
    dispatch(setShowPreviewCoupon(false));
    setActiveItem({
      id,
      type
    });
  };
  return <div className={styles.root} data-sentry-component="CouponPreviewBody" data-sentry-source-file="CouponPreviewBody.tsx">
      {isShowProgress && <div className={styles.progress}>
          <CouponCreateProgress duration={statusDelay || defaultProgressDuration} />
        </div>}
      {!isShowProgress && <div className={styles.contentWrapper}>
          <div className={styles.header}>
            <CouponQuickBetSwitch disabled={!isAuth} />
          </div>
          <div className={styles.main}>
            {!selectedBets.length && !isQuickBets && <CouponEmptyBlock />}
            {!isQuickBets && <CouponBetsCounter />}
            {!isQuickBets && isAuth && !!firstFreebetAndBonusAccount?.length && <div className={styles.accountItems}>
                {firstFreebetAndBonusAccount.map(item => {
            return <CouponAccountSelectItem {...item} text={t(item.text)} amount={formatPriceByCurrencyCodeWithLocale(item.amount, currency)} onClick={() => handleSelectItem({
              id: item.id,
              type: item.type
            })} key={item.id + item.type} className={cn(styles.selectItem, {
              [styles.freebetBorder]: item.type === 'FREEBET'
            })} />;
          })}
              </div>}
            {isQuickBets && <CouponSum />}
          </div>
          {(!isAuth || isAuth && isQuickBets) && <div className={styles.footer}>
              <CouponSubmit classes={{
          button: styles.submitButton,
          buttonContent: styles.submitButtonContent
        }} />
            </div>}
          <ToastContainer {...commonToastOptions} position="bottom-center" containerId={couponToastContainerId} />
        </div>}
    </div>;
};
export { CouponPreviewBody };